// React.
import React from 'react';

// Material UI.
import Paper from '@material-ui/core/Paper';

// Components.
import LabelsSettings from '../settings/LabelsSettings';

// Styles.
import useStyles from './SettingsStyles';

const LabelsSettingsPage = () => {
  const classes = useStyles();

  return (
    <Paper className={ classes.paper } elevation={3} square={false} variant="elevation">
      <LabelsSettings/>
    </Paper>
  )
}

export default LabelsSettingsPage;
